/**
 * Formatea un número de teléfono según la longitud
 * @param {string} value - Valor actual del campo
 * @returns {string} - Número de teléfono formateado
 */
export const formatPhoneNumber = (value: string): string => {
  // Remover todos los caracteres no numéricos
  const numbers = value.replace(/\D/g, "");

  // Si no hay números, retornar vacío
  if (numbers.length === 0) return "";

  // Aplicar formato según la longitud
  if (numbers.length <= 2) {
    return `+${numbers}`;
  } else if (numbers.length <= 5) {
    return `+${numbers.slice(0, 2)} ${numbers.slice(2)}`;
  } else if (numbers.length <= 8) {
    return `+${numbers.slice(0, 2)} ${numbers.slice(2, 5)}-${numbers.slice(5)}`;
  } else if (numbers.length <= 11) {
    return `+${numbers.slice(0, 2)} ${numbers.slice(2, 5)}-${numbers.slice(5, 8)}-${numbers.slice(8)}`;
  } else {
    // Limitar a 12 dígitos máximo
    return `+${numbers.slice(0, 2)} ${numbers.slice(2, 5)}-${numbers.slice(5, 8)}-${numbers.slice(8, 12)}`;
  }
};
